(function () {
  function handleFromHref(href) {
    if (!href) return null;
    var m = href.match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function swap(img, handle) {
    var cuts = window.EB_CUTOUTS || {};
    var url = handle && cuts[handle];
    if (!url || !img || img.dataset.ebCut === url) return;
    img.dataset.ebCut = url;
    img.src = url;
    img.removeAttribute("srcset");
    img.style.background = "transparent";
    img.style.objectFit = "contain";
  }

  function cutouts() {
    document.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      var h = handleFromHref(a.getAttribute("href"));
      a.querySelectorAll("img").forEach(function (img) {
        swap(img, h);
      });
    });
    var path = location.pathname.match(/\/products\/([^\/]+)/);
    if (path) {
      document
        .querySelectorAll(
          "media-gallery img, .product-media img, .product-gallery img, .product-information img"
        )
        .forEach(function (img) {
          swap(img, path[1]);
        });
    }
  }

  function rewriteNav() {
    var map = [
      { test: /\/collections\/boost-for-you\/?$/, href: "/collections/all", text: "Shop" },
      { test: /\/collections\/boosted-brews\/?$/, href: "/products/essentia-member", text: "Membership" },
      { test: /\/pages\/contact/, href: "/pages/contact", text: "Contact" },
      { test: /\/pages\/essentiaboost-home/, href: "/#why", text: "Why us" },
    ];
    document.querySelectorAll("#header-group a").forEach(function (a) {
      var href = (a.getAttribute("href") || "").split("?")[0];
      map.forEach(function (item) {
        if (!item.test.test(href)) return;
        a.setAttribute("href", item.href);
        var title = a.querySelector(
          ".menu-list__link-title, .menu-drawer__menu-item-text, span"
        );
        if (title) title.textContent = item.text;
        else a.textContent = item.text;
      });
    });
  }

  function hideStaleMemberCopy() {
    if (!/\/products\/essentia-member/.test(location.pathname)) return;
    document.querySelectorAll("p, li, .rte, .product-details").forEach(function (el) {
      var t = el.textContent || "";
      if (t.indexOf("$12.99 covers") !== -1 || t.indexOf("Essentia Member is the refill club") !== -1) {
        el.style.display = "none";
      }
    });
  }

  function hideMemberCardOnCollections() {
    if (location.pathname.indexOf("/collections/") === -1) return;
    document.querySelectorAll('a[href*="/products/essentia-member"]').forEach(function (a) {
      if (a.classList.contains("eb-btn") || a.classList.contains("eb-card")) return;
      var card = a.closest("product-card, .product-card, li.product-grid__item, .product-grid__item");
      if (card) card.style.display = "none";
    });
  }

  function run() {
    cutouts();
    rewriteNav();
    hideStaleMemberCopy();
    hideMemberCardOnCollections();
  }

  run();
  document.addEventListener("DOMContentLoaded", run);
  document.addEventListener("shopify:section:load", run);
  if (window.MutationObserver) {
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(run, 80);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
